//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr } from '@shared/SchemaTypes'
import { Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { ERC20Wei, otAssert } from '@shared/conversions'

import { approveDepositToPool } from '@shared/poolActions'

export const approveDepositToPoolTx =
  (props: { poolAddr: EthAddr; amountWei: ERC20Wei }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.POOL_DEPOSIT_APPROVE
    const { poolAddr, amountWei } = props
    try {
      const { webSocket, userConnection } = getState().chainState

      logOT.info(`--- userConnection`, userConnection)
      // logOT.info(`--- userConnection2`, userConnection)

      const { chainConfigurationName, providerReadOnly } = getState().chainState.chainConfiguration
      otAssert(providerReadOnly, 'providerReadOnly is not defined')
      otAssert(userConnection, 'userConnection is not defined')
      const { accountAddr, roleEnum, signer } = userConnection
      assertRole(roleEnum, RoleEnum.LENDER)

      logOT.debug('pooApproveDepositTx ', accountAddr, poolAddr, amountWei)

      await approveDepositToPool(
        webSocket,
        signer as Signer,
        providerReadOnly,
        poolAddr,
        amountWei,
        chainConfigurationName
      )

      dispatch(poolActions.approveDepositToPoolSuccess({ poolAddr, amountWei }))
    } catch (e: any) {
      dispatch(poolActions.depositToPoolFail({ poolAddr, amountWei }))

      await dispatchError(dispatch, e, activity, 1013)
    }
  }
